// Vagas salvas: no localStorage para o visitante (M2) e na conta para quem entrou (M7 parte 6, decisão 78). Na conta, o
// servidor manda e o aparelho espelha a lista que chega no GetUsuarioLogado.
import { enviarFormulario } from './api';
import { config, url } from './config';

const _chave = 'v2VagasSalvas';
// De quem é a lista deste aparelho (o id da pessoa que entrou); sem dono, são salvas de visitante.
const _chaveDono = 'v2VagasSalvasDono';
// Hotsite: as salvas que esta página mostrou e o recorte por empresa da conta não devolve (a de outra empresa que a
// segmentação lista); ficam só neste endereço e entram de novo em cada sincronização.
const _chaveForaRecorte = 'v2VagasSalvasForaRecorte';
const _limite = 50;

function _gravar(lista) {
    try {
        localStorage.setItem(_chave, JSON.stringify(lista.slice(0, _limite)));
        return true;
    } catch {
        return false;
    }
}

function _dono() {
    try {
        return localStorage.getItem(_chaveDono);
    } catch {
        return null;
    }
}

function _marcarDono(id) {
    try {
        if (id === null) {
            localStorage.removeItem(_chaveDono);
        } else {
            localStorage.setItem(_chaveDono, String(id));
        }
    } catch {
        // Sem armazenamento, a lista também não fica no aparelho.
    }
}

function _foraRecorte() {
    try {
        const lista = JSON.parse(localStorage.getItem(_chaveForaRecorte) || '[]');
        return Array.isArray(lista) ? lista.map(Number).filter(n => n > 0) : [];
    } catch {
        return [];
    }
}

function _gravarForaRecorte(lista) {
    try {
        if (lista.length) {
            localStorage.setItem(_chaveForaRecorte, JSON.stringify(lista.slice(0, _limite)));
        } else {
            localStorage.removeItem(_chaveForaRecorte);
        }
    } catch {
        // Sem armazenamento, a lista também não fica no aparelho.
    }
}

// No documento: qualquer script da página (e o teste de tela) vê se a lista já é a da conta.
export const salvasNaConta = () => document.documentElement.dataset.salvasConta === '1';

export function vagasSalvas() {
    try {
        const lista = JSON.parse(localStorage.getItem(_chave) || '[]');
        return Array.isArray(lista) ? lista.map(Number).filter(n => n > 0) : [];
    } catch {
        return [];
    }
}

export const estaSalva = id => vagasSalvas().includes(Number(id));

// Devolve se a vaga ficou salva (null se não deu: armazenamento bloqueado ou, na conta, o servidor recusou). A mais recente
// vai para o começo.
// Aparelho de uma conta antes de a lista dela chegar: espera a sincronização (até 3 s), senão a gravação local seria
// apagada por ela logo depois.
function _esperarConta() {
    if (_dono() === null || salvasNaConta()) {
        return Promise.resolve();
    }
    return new Promise(pronto => {
        const limite = setTimeout(pronto, 3000);
        document.addEventListener('v2:salvas', () => {
            clearTimeout(limite);
            pronto();
        }, { once: true });
    });
}

export async function alternarSalva(id) {
    await _esperarConta();
    id = Number(id);
    const outras = vagasSalvas().filter(x => x !== id);
    const salvou = !estaSalva(id);
    let lista = salvou ? [id, ...outras] : outras;
    if (salvasNaConta()) {
        const dados = new FormData();
        dados.append('vagaID', String(id));
        dados.append('salvar', String(salvou));
        let resposta = null;
        try {
            resposta = await enviarFormulario(url('/Vagas/AlternarSalvaV2'), dados);
        } catch {
            resposta = null;
        }
        if (!resposta?.sucesso || !Array.isArray(resposta.salvas)) {
            return null;
        }
        lista = resposta.salvas.map(Number);
        // No hotsite a lista volta com o recorte por empresa (VagaDataAccess._listaSalvasV2): a vaga que esta página mostrou e
        // ele não reconhece continua salva aqui.
        const fora = _foraRecorte().filter(x => x !== id && !lista.includes(x));
        if (salvou && !lista.includes(id)) {
            fora.unshift(id);
        }
        _gravarForaRecorte(fora);
        lista = [...fora, ...lista];
        _gravar(lista);
    } else if (!_gravar(lista)) {
        return null;
    }
    atualizarContadorSalvas();
    return salvou;
}

// Na 1ª vez que a pessoa entra neste aparelho, as salvas de visitante passam para a conta; depois disso, o aparelho só espelha
// a conta (o que foi removido em outro aparelho não volta). Sem login, a lista de uma conta sai do aparelho. Avisa a página
// (evento v2:salvas) quando a lista mudou.
export async function sincronizarSalvas(u) {
    // No hotsite o servidor manda só as salvas da empresa dele (o aparelho tem uma lista por endereço).
    if (!u || u.erro) {
        return;
    }
    const local = vagasSalvas();
    if (!u.logado) {
        delete document.documentElement.dataset.salvasConta;
        if (_dono() !== null) {
            _gravar([]);
            _gravarForaRecorte([]);
            _marcarDono(null);
            atualizarContadorSalvas();
            document.dispatchEvent(new CustomEvent('v2:salvas', { detail: { mudou: local.length > 0 } }));
        }
        return;
    }
    if (!Array.isArray(u.salvas) || !u.id) {
        return;
    }
    let conta = u.salvas.map(Number);
    let foraNovas = [];
    if (_dono() === null && local.some(id => !conta.includes(id))) {
        const dados = new FormData();
        dados.append('ids', local.join(','));
        try {
            const resposta = await enviarFormulario(url('/Vagas/MesclarSalvasV2'), dados);
            if (!resposta?.sucesso || !Array.isArray(resposta.salvas)) {
                return;
            }
            conta = resposta.salvas.map(Number);
        } catch {
            // Tenta de novo na próxima página; até lá, o aparelho fica com a lista dele.
            return;
        }
        // No hotsite a conta volta com o recorte por empresa: a salva de visitante que ele não reconhece continua salva aqui,
        // como no alternarSalva (sem isso ela sumia da tela ao entrar).
        if (config().hotsite) {
            foraNovas = local.filter(id => !conta.includes(id));
        }
    }
    // As de fora do recorte são de quem as salvou aqui: outra pessoa neste aparelho começa sem elas.
    if (_dono() !== String(u.id)) {
        _gravarForaRecorte([]);
    }
    const fora = [...foraNovas, ..._foraRecorte()].filter((x, i, todas) => !conta.includes(x) && todas.indexOf(x) === i);
    _gravarForaRecorte(fora);
    conta = [...fora, ...conta];
    document.documentElement.dataset.salvasConta = '1';
    _gravar(conta);
    _marcarDono(u.id);
    atualizarContadorSalvas();
    document.dispatchEvent(new CustomEvent('v2:salvas', { detail: { mudou: conta.join(',') !== local.join(',') } }));
}

// Número na aba "Salvas" da barra inferior, como na v36, e no "Vagas Salvas" da lateral de quem entrou (v43).
export function atualizarContadorSalvas() {
    const n = vagasSalvas().length;
    document.querySelectorAll('.cx-lat [data-u="salvas"]').forEach(el => {
        el.hidden = !n;
        el.textContent = n || '';
    });
    document.querySelectorAll('.cx-lat [data-lat="salvas"]').forEach(el => {
        if (n) {
            el.setAttribute('aria-label', `${el.title}, ${n}`);
        } else {
            el.removeAttribute('aria-label');
        }
    });
    const aba = document.querySelector('.bnav [data-bn="salvas"]');
    if (!aba) {
        return;
    }
    let marca = aba.querySelector('.bnav__n');
    if (!n) {
        marca?.remove();
        return;
    }
    if (!marca) {
        marca = document.createElement('span');
        marca.className = 'bnav__n';
        aba.append(marca);
    }
    marca.textContent = n;
}
